// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserLastLoginCell} from './UserLastLoginCell'
import {UserTwoStepsCell} from './UserTwoStepsCell'
import {UserActionsCell} from './UserActionsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'
import "./style.css"
// import moment from 'moment'

const usersColumns: ReadonlyArray<Column<User>> = [
  // {
  //   Header: (props) => <UserSelectionHeader tableProps={props} />,
  //   id: 'selection',
  //   Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index].id} />,
  // },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='From' className='w-180'  />,
    id: 'from',
    Cell: ({...props}) => <UserInfoCell user={props.data[props.row.index]} id="from" />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='For' className='w-180'  />,
    id: 'for',
    Cell: ({...props}) => <UserInfoCell user={props.data[props.row.index]} id="for" />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Reservation Number' className='w-180' />,
    id:'reservation_code',
    accessor: 'reservation_code'
  },

  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Reviews' className='w-240'  />,
    id:'review',
    Cell: ({...props}) => {
        console.log(props)
        return <div>
            <div>{props.data[props.row.index]?.comment}</div>
            {props.data[props.row.index]?.reply && <div>
                <div style={{ marginTop: 4, fontSize: 12, color: '#4a4a4a' }}>Property Member Reply:</div>
                <div>{props.data[props.row.index]?.reply}</div>
            </div>}
        </div>
    },
    // accessor: 'comment'
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Ratings' className='w-135' />
    ),
    id: 'rating',
    Cell: ({...props}) => <UserTwoStepsCell rating={props.data[props.row.index]?.ratings} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Created At' className='w-180' />
    ),
    accessor: 'createdAt',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Updated At' className='w-180' />
    ),
    accessor: 'updatedAt',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='' className='w-60'  />
    ),
    id: 'actions',
    Cell: ({...props}) => <UserActionsCell id={props.data[props.row.index]} />,
  },
]

export {usersColumns}
